// components/ui/input.js
import React from 'react';

const Input = ({ className = '', ...props }) => {
  return (
    <input
      className={`aa-input ${className}`}
      {...props}
    />
  );
};

export { Input };